import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Stack,
  IconButton,
  InputAdornment,
  Typography,
  Popover,
  Button,
  Tooltip,
  Container,
  Grid,
} from "@mui/material";
import { connect } from "react-redux";
import {
  CreateInternalDraftMessage,
  endInteraction,
} from "../../../../Redux/Actions/actions";
import { PaperPlaneTilt, Trash, PlusCircle } from "@phosphor-icons/react";
import { MdAttachFile } from "react-icons/md";
import { BiMessage } from "react-icons/bi";
import { FiSmile } from "react-icons/fi";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import axios from "axios";
import { toast } from "react-toastify";
import { BaseUrl, MsgSizeCofig } from "../../../../Container/BaseUrl/BaseUrl";
import CannedMessage from "../chat-component-model/CannedMessage";
import PreViewmodal from "../chat-component-model/PreViewmodal";
import { toaststyle } from "../../../../Utils/toaststyle";
import { StyledInput } from "../../../../CustomComponent/ChatInputComponent";
import { useDebounce } from "../../../../Layout/Contacts/hooks";

const mapStateToProps = (state) => {
  return {
    chatid: state.data.chatid,
    chat: state.data.chat,
    externalChatData: state.contactListData.externalChatData,
    chatSessionId: state.contactListData.chatSessionId,
  };
};

const CoversationFooterInternal = (props) => {
  const { handleSendMsg, handleTyping } = props;
  let permission = JSON.parse(localStorage.getItem("permission"));
  const datas = JSON.parse(localStorage.getItem("tokenAgent"));
  const selectedChat = JSON.parse(localStorage.getItem("client"));
  const [message, setMessage] = useState(``);
  const [showMessage, setShowMessage] = useState([]);
  const [showcannedmodal, setShowcannedmodal] = useState(false);
  const [showPreviewmodal, setshowPreviewmodal] = useState(false);
  const [uploadedFile, setuploadedFile] = useState();
  const [openEmojiBox, setOpenEmojiBox] = useState(null);
  const Emojiopen = Boolean(openEmojiBox);
  const EmojiId = Emojiopen ? "simple-popover" : undefined;
  const [openCannedMsg, setOpenCannedMsg] = useState(null);
  const cannedMsgopen2 = Boolean(openCannedMsg);
  const cannedMsgId = cannedMsgopen2 ? "simple-popover" : undefined;
  const inputRef = useRef(null);
  const [cursorPosition, setcursorPosition] = useState();
  const debouncedSearch = useDebounce(message);

  const onEmojiClick = (e) => {
    const ref = inputRef.current.children[0].children[0];
    const start = message.substring(0, ref.selectionStart);
    const end = message.substring(ref.selectionStart);
    const text = start + e.native + end;
    setMessage(text);
    const newCursorPosition = start.length + e.native.length;
    setTimeout(() => {
      ref.focus();
      ref.setSelectionRange(newCursorPosition, newCursorPosition);
    }, 0);
    setOpenEmojiBox(null);
  };
  const onCannedMsg = (value) => {
    const ref = inputRef.current.children[0].children[0];
    const start = message.substring(0, ref.selectionStart);
    const end = message.substring(ref.selectionStart);
    const text = start + value + end;
    setMessage(text);
    const newCursorPosition = start.length + value.length;
    setTimeout(() => {
      ref.focus();
      ref.setSelectionRange(newCursorPosition, newCursorPosition);
    }, 0);

    setOpenCannedMsg(null);
  };
  const sendMessage = (event) => {
    if (
      (event.key === "Enter" && !event.shiftKey && !event.altkey) ||
      event._reactName === "onClick"
    ) {
      event.preventDefault();

      const trimmedMessage = message.trim();
      if (trimmedMessage.length === 0) return;
      if (trimmedMessage.length >= MsgSizeCofig)
        return toast.error("More than 3000 Characters Not Allowed", toaststyle);
      handleSendMsg(trimmedMessage, "TEXT", "");
      setMessage("");
      inputRef.current.focus();
    } else if (event.key === "Enter" && event.shiftKey) {
      event.preventDefault();
      setMessage(message + "\n");
    } else if (event.key === "Enter" && event.altKey) {
      event.preventDefault();
      setMessage(message + "\n");
    }
    if (inputRef.current.children[0].children[1]) {
      inputRef.current.children[0].children[1].scrollTop =
        inputRef.current.children[0].children[1].scrollHeight;
    }
  };
  const retrieveScannedMsg = () => {
    let data = {
      offset: "0",
      limit: "200",
      agent_id: datas.agent_id,
    };
    axios
      .post(BaseUrl + "/scannedMessage/listMessage", data, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        if (res.data.status == true) {
          setShowMessage(res.data.data);
        } else {
          setShowMessage([]);
        }
      })
      .catch((error) => {});
  };
  const deleteScannedMessage = (id) => {
    let data = {
      id: id,
    };
    axios
      .post(BaseUrl + "/scannedMessage/deleteScannedMessage", data, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        if (res.status) {
          retrieveScannedMsg();
          toast.success("Canned Message Deleted", toaststyle);
        }
      })
      .catch((error) => {});
  };
  const sendFile = () => {
    if (uploadedFile) {
      handleSendMsg(
        uploadedFile.attachmentUrl,
        uploadedFile.fileType,
        uploadedFile.filename
      );
    }
  };
  useEffect(() => {
    inputRef.current.children[0].children[1].selectionEnd = cursorPosition;
  }, [cursorPosition]);

  useEffect(() => {
    setMessage(
      selectedChat
        ? selectedChat.draftMessage
          ? selectedChat.draftMessage
          : ``
        : ``
    );
  }, [props.chatSessionId]);

  useEffect(() => {
    props.CreateInternalDraftMessage(message);
    const ref = inputRef.current.children[0].children[1];
    ref.focus();
  }, [debouncedSearch]);

  return (
    <>
      <Grid
        container
        className="mt-0"
        sx={{
          height: "auto",
          backgroundColor: "white",
          maxHeight: 260,
          borderRadius: "0 0 7px 0",
          boxShadow:
            "rgba(50, 50, 93, 0.25) 1px -2px 4px -1px,rgba(0, 0, 0, 0.3) 0px 0px 1px -1px",
        }}
        p={1}
      >
        <Grid item xs={12} sx={{ paddingRight: "16px" }}>
          <Grid container spacing={3}>
            <Grid item xs={11}>
              <StyledInput
                autoFocus
                className="CONTACT-LIST-AREA"
                fullWidth
                multiline
                placeholder="Type a message"
                value={message}
                onChange={(e) => {
                  inputRef.current.children[0].children[1].scrollTop =
                    inputRef.current.children[0].children[1].scrollHeight;
                  setMessage(`${e.target.value}`);
                  handleTyping();
                }}
                ref={inputRef}
                onKeyDown={sendMessage}
                variant="filled"
                InputProps={{
                  disableUnderline: true,
                  startAdornment: (
                    <InputAdornment position="end">
                      {permission.map((module) => {
                        if (module.moduleName === "CHAT_INTERACTION") {
                          const value = module.screen.find(
                            (item) =>
                              item.screenId === "EMOJI" &&
                              item.read &&
                              item.write
                          );

                          if (value) {
                            return (
                              <Tooltip title="Emoji">
                                <IconButton
                                  aria-label="smile"
                                  size="small"
                                  aria-describedby={EmojiId}
                                  onClick={(e) => {
                                    setOpenEmojiBox(e.currentTarget);
                                  }}
                                >
                                  <FiSmile />
                                </IconButton>
                              </Tooltip>
                            );
                          } else {
                            return (
                              <Tooltip title="Contact Admin">
                                <IconButton aria-label="smile" size="small">
                                  <FiSmile />
                                </IconButton>
                              </Tooltip>
                            );
                          }
                        }
                      })}
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <>
                        {permission.map((module) => {
                          if (module.moduleName === "CHAT_INTERACTION") {
                            const value = module.screen.find(
                              (item) =>
                                item.screenId === "SCANNED_MESSAGE" &&
                                item.read &&
                                item.write
                            );

                            if (value) {
                              return (
                                <Tooltip title="Canned Message">
                                  <IconButton
                                    size="small"
                                    aria-describedby={cannedMsgId}
                                    onClick={(e) => {
                                      retrieveScannedMsg();
                                      setOpenCannedMsg(e.currentTarget);
                                    }}
                                  >
                                    <BiMessage />
                                  </IconButton>
                                </Tooltip>
                              );
                            } else {
                              return (
                                <Tooltip title="Contact Admin">
                                  <IconButton size="small">
                                    <BiMessage />
                                  </IconButton>
                                </Tooltip>
                              );
                            }
                          }
                        })}

                        <Popover
                          sx={{
                            "& .MuiPaper-root": {
                              borderRadius: "7px",
                              height: "300px",
                              width: "300px",
                              boxShadow:
                                "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
                              scrollbarWidth: "none",
                              "-ms-overflow-style": "none",
                              "&::-webkit-scrollbar": {
                                width: "0",
                              },
                            },
                          }}
                          id={cannedMsgId}
                          open={cannedMsgopen2}
                          anchorEl={openCannedMsg}
                          onClose={() => {
                            setOpenCannedMsg(null);
                          }}
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "center",
                          }}
                          transformOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                          }}
                        >
                          <Box
                            sx={{
                              gap: "10px",
                              display: "flex",
                              flexDirection: "column",
                              height: "100%",
                              width: "100%",
                            }}
                          >
                            <Box
                              className="border-bottom"
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                padding: "5px 10px",
                                alignItems: "center",
                                height: "50px",
                                width: "100%",
                                boxShadow:
                                  "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontWeight: 600,
                                  fontSize: "14px",
                                  color: "#0b3363",
                                }}
                              >
                                Canned Message
                              </Typography>
                              <IconButton
                                size="small"
                                onClick={() => {
                                  setShowcannedmodal(true);
                                }}
                              >
                                <PlusCircle size={18} weight="bold" />
                              </IconButton>
                            </Box>

                            <div
                              className="card-body canned_card CONTACT-LIST-AREA"
                              style={{
                                height: "calc(100% - 40px)",
                                padding: "5px 10px",
                                overflowY: "scroll",
                              }}
                            >
                              <Stack sx={{ width: "100%" }}>
                                {showMessage.length > 0 ? (
                                  showMessage.map((item, index) => (
                                    <Container maxWidth="sm">
                                      <div
                                        className="row border-bottom justify-content-center align-items-center bg-white hover-overlay py-2"
                                        style={{ cursor: "pointer" }}
                                        key={index}
                                        onClick={() => {
                                          onCannedMsg(item.message);
                                          handleClose2();
                                        }}
                                      >
                                        <Stack
                                          direction={"row"}
                                          alignItems={"center"}
                                          justifyContent={"space-between"}
                                          sx={{ padding: "0" }}
                                        >
                                          <Typography
                                            sx={{
                                              fontSize: "12px",
                                              width: "180px",
                                            }}
                                          >
                                            {item.message}
                                          </Typography>
                                          <IconButton
                                            onClick={() => {
                                              deleteScannedMessage(item.id);
                                            }}
                                            color="error"
                                            size="small"
                                          >
                                            <Trash
                                              size={13}
                                              cursor={"pointer"}
                                            />
                                          </IconButton>
                                        </Stack>
                                      </div>
                                    </Container>
                                  ))
                                ) : (
                                  <div className="d-flex justify-content-center align-items-center h-100 text-muted">
                                    <div>
                                      <div className=""></div>
                                      <div>No Canned Message</div>
                                    </div>
                                  </div>
                                )}
                              </Stack>
                            </div>
                          </Box>
                        </Popover>

                        {permission.map((module) => {
                          if (module.moduleName === "CHAT_INTERACTION") {
                            const value = module.screen.find(
                              (item) =>
                                item.screenId === "ATTACH_FILE" &&
                                item.read &&
                                item.write
                            );

                            if (value) {
                              return (
                                <Tooltip title="Attach file">
                                  <IconButton
                                    size="small"
                                    className="me-1"
                                    onClick={() => {
                                      setshowPreviewmodal(true);
                                    }}
                                  >
                                    <MdAttachFile />
                                  </IconButton>
                                </Tooltip>
                              );
                            } else {
                              return (
                                <Tooltip title="Contact Admin">
                                  <IconButton size="small" className="me-1">
                                    <MdAttachFile />
                                  </IconButton>
                                </Tooltip>
                              );
                            }
                          }
                        })}
                      </>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={1}>
              <Stack alignItems={"center"} justifyContent={"center"}>
                <Button
                  disableElevation
                  onClick={sendMessage}
                  variant="contained"
                  sx={{ height: "48px" }}
                >
                  <PaperPlaneTilt
                    size={15}
                    color="white"
                    weight="fill"
                    className="me-2"
                  />{" "}
                  Send
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {showcannedmodal && (
        <CannedMessage
          showcannedmodal={showcannedmodal}
          handleClose={() => {
            setShowcannedmodal(false);
          }}
          retrieveScannedMsg={retrieveScannedMsg}
        />
      )}

      {showPreviewmodal && (
        <PreViewmodal
          showPreviewmodal={showPreviewmodal}
          uploadedFile={uploadedFile}
          sendMessage={sendFile}
          UploadFrom={""}
          setuploadedFile={setuploadedFile}
          handleClose={() => {
            setshowPreviewmodal(false);
            setuploadedFile(null);
          }}
        />
      )}

      <Popover
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "13px",
            height: "310px",
            scrollbarWidth: "none", // Hide the scrollbar in Firefox
            "-ms-overflow-style": "none", // Hide the scrollbar in IE and Edge
            "&::-webkit-scrollbar": {
              width: "0", // Hide the scrollbar in WebKit browsers (Chrome, Safari)
            },
          },
        }}
        id={EmojiId}
        open={Emojiopen}
        anchorEl={openEmojiBox}
        onClose={() => {
          setOpenEmojiBox(null);
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Picker
          data={data}
          onEmojiSelect={onEmojiClick}
          theme={"light"}
          perLine={8}
        />
      </Popover>
    </>
  );
};

export default connect(mapStateToProps, {
  endInteraction,
  CreateInternalDraftMessage,
})(CoversationFooterInternal);
